import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  getActiveThoughtLeaderships,
  getActiveTopics,
  getActiveAuthors,
  getActiveProductResults,
  getFundsByProductType,
  getSubscribedLiteratureForFunds,
  getWholesalerLabel,
  getSubscriptionsWithoutProductInsights,
} from '../Helper/helper.js'

import {
  SERVICE_LABEL_WHOLESALER,
  SERVICE_LABEL_ADVISOR,
  COLLECTIVE_INVESTMENT_TRUSTS,
} from '../Helper/constants.js'

import NoSubscriptions from './NoSubscriptions.jsx'
import FundListItem from './FundListItem.jsx'
import ConfirmModal from '../../ConfirmModal/ConfirmModal.jsx'

import './your-subscriptions.css'

import DOMPurify from 'dompurify'

function YourSubscriptions(props) {
  const [unsubscribeInProcess, setUnsubscribeInProcess] = useState(false)

  const {
    handleSubscribe,
    productTypes,
    wholesalerLabels,
    subscriptions,
    userSubscriptionProfile,
    handleUnsubscribeFund,
    handleUnsubscribeSubscriptions,
    handleManageFundClick,
    funds,
  } = props

  const getActiveSubscriptionsCount = () => {
    return (
      activeInsightsCount + activeLiteratureCount + activeProductInsightsCount
    )
  }

  const getInsightsSubscriptionsCount = (payload) => {
    return payload.reduce((count, subscription) => {
      return count + (subscription.checked ? 1 : 0)
    }, 0)
  }

  const getFundLiteratureSubscriptionsCount = () => {
    let counter = 0
    funds.forEach((fund) => {
      counter = fund.activeLiterature.reduce((count, doc) => {
        return count + (doc.selected ? 1 : 0)
      }, counter)
    })
    return counter
  }

  const activeProductInsights = getActiveProductResults(subscriptions)
  const activeProductInsightsCount = getInsightsSubscriptionsCount(
    activeProductInsights
  )
  const activeInsightsCount = getInsightsSubscriptionsCount(
    getSubscriptionsWithoutProductInsights(subscriptions)
  )
  const activeLiteratureCount = getFundLiteratureSubscriptionsCount()

  const getSubscriptionUnsubscribeHtml = (subscription) => {
    const wholesalerLabel =
      subscription &&
      getWholesalerLabel(wholesalerLabels, subscription.wholesalerLabel)
    return subscription.checked ? (
      <h4
        key={'yourSubscriptions' + subscription.id}
        className="u-marginBottom3gu"
      >
        <span
          className="u-marginRight2gu"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(subscription.name),
          }}
        ></span>
        {userSubscriptionProfile.role === SERVICE_LABEL_WHOLESALER &&
          subscription.wholesalerLabel &&
          wholesalerLabel && (
            <div className="From-you u-marginBottom2gu u-inlineBlock u-bgColorLight u-paddingHoriz2gu u-textNormal">
              <div className="u-textSizeMsrm1">
                {
                  (
                    wholesalerLabels.find(
                      (label) => label.key === subscription.wholesalerLabel
                    ) || { label: '' }
                  ).label
                }
              </div>
            </div>
          )}
        <button
          value={subscription.id}
          onClick={handleSubscribe}
          data-checked={false}
          className="Link u-textSecondary"
          data-analytics="cesc-unsubscribe-one"
        >
          Unsubscribe
        </button>
      </h4>
    ) : null
  }

  const renderSubscriptionSection = (typedSubscriptions, headerText) => {
    const isASubscriptionChecked = typedSubscriptions.reduce(
      (isChecked, subscription) => {
        return isChecked || subscription.checked
      },
      false
    )

    return (
      isASubscriptionChecked > 0 && (
        <div
          className={`${
            headerText === 'Product Insights'
              ? 'u-lg-size6of12'
              : 'u-lg-size4of12'
          } u-sm-sizeFull Subscription-insights`}
        >
          <h5 className="u-textSizeMsrp1 u-marginBottom4gu">{headerText}</h5>
          {typedSubscriptions
            .sort((a, b) =>
              (a.name || '').localeCompare(b.name || '', 'en', {
                sensitivity: 'base',
              })
            )
            .map((subscription) => {
              return getSubscriptionUnsubscribeHtml(subscription)
            })}
        </div>
      )
    )
  }

  const unsubscribeAllHandler = (e, confirmed) => {
    if (!confirmed) {
      setUnsubscribeInProcess(true)
    } else {
      e.preventDefault()
      e.stopPropagation()

      if (confirmed === 1) {
        handleUnsubscribeSubscriptions()
      }

      setUnsubscribeInProcess(false)
    }
  }

  const currentSubscriptionCount = getActiveSubscriptionsCount()

  return (
    <React.Fragment>
      {currentSubscriptionCount < 1 ? (
        <NoSubscriptions
          handleSubscribe={handleSubscribe}
          userSubscriptionProfile={userSubscriptionProfile}
        />
      ) : (
        <React.Fragment>
          {/* If has subscriptions */}
          <hr className="Rule u-textColorBrand" />
          <div
            id="Your-subscriptions"
            className="Card Grid u-lg-sizeConstrained u-marginBottom4gu u-bgColorWhite u-sm-paddingHoriz3gu u-sm-paddingVert6gu"
          >
            <div className="Grid u-sizeFull u-marginBottom3gu">
              <div className="u-flex u-sm-marginBottom3gu">
                <h2 className="u-flexGrow1 u-marginRight1gu">
                  Your subscriptions ({currentSubscriptionCount})
                </h2>
                <button
                  onClick={unsubscribeAllHandler}
                  className="Button Button--tertiary u-flexJustifyEnd u-textNoTransform u-textKernDefault"
                >
                  Unsubscribe from Selected Communications
                </button>
              </div>

              {/* If unsub all success */}
              {/* {successMessageFlag && <SuccessMessage />} */}
            </div>
            {activeInsightsCount > 0 && (
              <>
                <h3 className="u-marginBottom4gu">Insights</h3>

                {/* If success */}
                {/* <SuccessMessage></SuccessMessage> */}

                <div className="Grid u-sizeFull u-paddingLeft3gu">
                  {renderSubscriptionSection(
                    getActiveThoughtLeaderships(subscriptions),
                    'Thought Leadership'
                  )}
                  {renderSubscriptionSection(
                    getActiveTopics(subscriptions),
                    'Topics'
                  )}
                  {renderSubscriptionSection(
                    getActiveAuthors(subscriptions),
                    'Authors'
                  )}
                </div>
              </>
            )}
            {(activeLiteratureCount > 0 || activeProductInsightsCount > 0) &&
              activeInsightsCount > 0 && (
                <hr
                  className="Rule Rule--thin u-marginVert6gu"
                  role="presentation"
                />
              )}

            {(activeLiteratureCount > 0 || activeProductInsightsCount > 0) && (
              <h3 className="u-marginBottom4gu">Products</h3>
            )}
            {activeLiteratureCount > 0 && (
              <>
                {/* If success */}
                {/* <SuccessMessage></SuccessMessage> */}

                {productTypes.map((productType) => {
                  const fundsByProductType = getFundsByProductType(
                    funds,
                    productType.key
                  )
                  let hasDocs = false

                  fundsByProductType.map((fund) => {
                    const literatureDocs = getSubscribedLiteratureForFunds(fund)
                    if (literatureDocs.length > 0) {
                      hasDocs = true
                    }
                  })

                  // if subscription is CIT, only show subscription if user type is Advisor
                  const showSubscription =
                    productType.label === COLLECTIVE_INVESTMENT_TRUSTS
                      ? userSubscriptionProfile.role === SERVICE_LABEL_ADVISOR
                        ? true
                        : false
                      : true

                  return (
                    productType.key !== 'all' &&
                    hasDocs &&
                    showSubscription && (
                      <div
                        key={'yourSubscriptionFund' + productType.key}
                        className="u-sizeFull u-marginLeft3gu u-marginBottom4gu"
                      >
                        {productType.label !== 'Coll'}
                        <h5 className="u-textSizeMsrp1 u-marginBottom3gu">
                          {productType.label}
                        </h5>
                        {fundsByProductType
                          .sort((a, b) =>
                            (a.name || '').localeCompare(b.name || '', 'en', {
                              sensitivity: 'base',
                            })
                          )
                          .map((fund) => (
                            <FundListItem
                              key={'yourSubscriptionFunds' + fund.id}
                              fund={fund}
                              wholesalerLabels={wholesalerLabels}
                              userSubscriptionProfile={userSubscriptionProfile}
                              handleUnsubscribeFund={handleUnsubscribeFund}
                              handleManageFundClick={handleManageFundClick}
                            />
                          ))}
                      </div>
                    )
                  )
                })}
              </>
            )}
            {activeProductInsightsCount > 0 && (
              <div className="Grid u-sizeFull u-paddingLeft3gu">
                {renderSubscriptionSection(
                  getActiveProductResults(subscriptions),
                  'Product Insights'
                )}
              </div>
            )}
          </div>
          {unsubscribeInProcess && (
            <ConfirmModal
              title="Please Confirm"
              text="Are you sure you want to unsubscribe from all of your subscriptions?"
              unsubscribeAllHandler={unsubscribeAllHandler}
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

YourSubscriptions.propTypes = {
  subscriptions: PropTypes.array.isRequired,
  funds: PropTypes.array.isRequired,
  productTypes: PropTypes.array.isRequired,
  wholesalerLabels: PropTypes.array.isRequired,
  userSubscriptionProfile: PropTypes.object.isRequired,
  handleSubscribe: PropTypes.func.isRequired,
  handleUnsubscribeFund: PropTypes.func.isRequired,
  handleUnsubscribeSubscriptions: PropTypes.func.isRequired,
  handleManageFundClick: PropTypes.func.isRequired,
}

export default YourSubscriptions
